<template>
    <return-button class="return-button" />
    <div class="main-container">
        <div class="title-header" style="margin: 20px 0">
            <h1 class="title">Información del Practicante</h1>
        </div>
        <!-- Información del Practicante -->
        <div class="info-practicante">
            <div class="data-section">
                <div class="data-row">
                    <span class="label">Nombre:</span>
                    <span class="value">{{
                        getPractitionerValue('Nombre')
                    }}</span>
                </div>
                <div class="data-row">
                    <span class="label">Apellido:</span>
                    <span class="value">{{
                        getPractitionerValue('Apellido')
                    }}</span>
                </div>
                <div class="data-row">
                    <span class="label">Especialidad:</span>
                    <span class="value">{{
                        getPractitionerValue('Especialidad')
                    }}</span>
                </div>
                <div class="data-row">
                    <span class="label">Universidad:</span>
                    <span class="value">{{
                        getPractitionerValue('Universidad')
                    }}</span>
                </div>
                <div class="data-row">
                    <span class="label">Cédula Profesional:</span>
                    <span class="value">{{
                        getPractitionerValue('Cédula Profesional')
                    }}</span>
                </div>
            </div>
        </div>

        <!-- Sección de Expediente -->
        <h2 class="titulos text-center">Información del Expediente</h2>
        <v-col>
            <v-row class="mr-4 ml-4 mt-4" no-gutters>
                <v-col cols="12" md="" class="d-flex justify-start mb-1">
                    <h2 class="titulos">Recetas</h2>
                </v-col>
                <v-col cols="12" md="6" class="d-flex justify-end mb-1">
                    <div class="cont-botones">
                        <router-link
                            :to="{
                                name: 'CrearPracticante',
                                params: { id: $route.params.id },
                            }">
                            <button
                                color="#4CABD3"
                                class="button boton-principal">
                                <v-icon>mdi-file-edit-outline</v-icon>
                                Editar practicante
                            </button>
                        </router-link>
                    </div>
                </v-col>
            </v-row>
            <v-row>
                <v-col>
                    <!-- Mensaje de error -->
                    <div v-if="errorEmpty" class="error-message">
                        {{ errorEmpty }}
                    </div>
                    <!-- Tabla de recetas -->
                    <EasyDataTable
                        v-if="groupedItemsArray.length > 0"
                        table-class-name="customize-table"
                        buttons-pagination
                        alternating
                        :headers="headers"
                        :items="groupedItemsArray"
                        :rows-per-page="rowsPerPage">
                        <template #item-operation="item">
                            <div class="operation-wrapper">
                                <v-icon
                                    icon="mdi-eye-outline"
                                    class="operation-icon"
                                    @click="verReceta(item.id)" />
                            </div>
                        </template>
                        <template #item-status="item">
                            <span
                                class="status"
                                :style="{ color: item.status.color }">
                                {{ item.status.text }}
                            </span>
                        </template>
                        <template #expand="item">
                            <div class="row-details">
                                <ul>
                                    <li
                                        v-for="(
                                            medicamento, i
                                        ) in item.medicamentos"
                                        :key="medicamento">
                                        {{ medicamento }},
                                        <span
                                            v-html="
                                                item.instruccionesDosis[i]
                                            "></span>
                                    </li>
                                </ul>
                            </div>
                        </template>
                    </EasyDataTable>
                </v-col>
            </v-row>
        </v-col>
    </div>

    <!-- Diálogo de receta -->
    <v-dialog v-model="dialogo" persistent>
        <prescriptionDialog
            :recipe-id="selectedRecipeId"
            @closeDialog="dialogo = false"
            @close="closeDialog"
            @click:outside="closeDialog" />
    </v-dialog>
</template>

<script>
import returnButton from '@/components/global/return-button.vue';
import { getPractitioner } from '@/api/practicante'
import { getMedRequestByPractitionerId } from '@/api/expedientes'
import EasyDataTable from 'vue3-easy-data-table';
import prescriptionDialog from '@/components/global/prescription-dialog.vue';
import { medication_request_status } from '@/utils/medication_request_status';

export default {
    computed: {
        groupedItems() {
            return this.items.reduce((acc, item) => {
                if (!acc[item.id]) {
                    acc[item.id] = {
                        ...item,
                        medicamentos: [],
                        instruccionesDosis: [],
                    };
                }
                acc[item.id].medicamentos.push(item.medicamento);
                acc[item.id].instruccionesDosis.push(item.instruccionesDosis);
                return acc;
            }, {});
        },
        groupedItemsArray() {
            return Object.values(this.groupedItems);
        },
    },
    methods: {
        getPractitionerValue(indicador) {
            const item = this.mostrarItemsPracticante.find(
                (item) => item.indicador === indicador,
            );
            return item ? item.valor : '';
        },
        showRow(row) {
            this.selectedRecipeId = row.id;
            this.dialogo = true;
        },
        verReceta(recipeId) {
            this.showRow({ id: recipeId });
        },
        closeDialog() {
            this.dialogo = false;
        },
        formDate(ISOdate) {
            const date = new Date(ISOdate);
            return date.toLocaleDateString('es-ES', {
                weekday: 'long',
                year: 'numeric',
                month: 'long',
                day: 'numeric',
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
            });
        },
        fetchMedications() {
            let id = this.$route.params.id;
            getMedRequestByPractitionerId(id)
                .then((medications) => {
                    if (medications && medications.length > 0) {
                        medications.forEach((medication) => {
                            medication.periodoLimiteInicio = this.formDate(
                                new Date(medication.periodoLimiteInicio),
                            );
                            medication.status =
                                medication_request_status[medication.status];
                        });
                        this.items = medications;
                    } else {
                        this.items = [];
                        this.errorEmpty =
                            'No hay datos disponibles en el expediente de este practicante';
                    }
                })
                .catch((error) => {
                    console.error('Error:', error);
                    this.items = [];
                    this.errorEmpty =
                        'No hay datos disponibles en el expediente de este practicante';
                });
        },
        fetchPractitionerDetails() {
            let id = this.$route.params.id;
            getPractitioner(id)
                .then((practitioner) => {
                    this.mostrarItemsPracticante = [
                        { indicador: 'Nombre', valor: practitioner.name[0] },
                        {
                            indicador: 'Apellido',
                            valor: practitioner.lastname[0],
                        },
                        {
                            indicador: 'Especialidad',
                            valor: practitioner.qualification[0]
                                .professionalLicense,
                        },
                        {
                            indicador: 'Universidad',
                            valor: practitioner.qualification[0].issuer
                                .reference,
                        },
                        {
                            indicador: 'Cédula Profesional',
                            valor: practitioner.qualification[0].identifier,
                        },
                    ];
                })
                .catch((error) => {
                    console.error(error);
                });
        },
    },
    mounted() {
        this.selectedPractitionerId = this.$route.params.id;
    },
    created() {
        this.fetchMedications();
        this.fetchPractitionerDetails();
    },
    components: {
        EasyDataTable,
        prescriptionDialog,
        'return-button': returnButton,
    },
    data() {
        return {
            medication_request_status,
            headers: [
                { text: 'Fecha', value: 'periodoLimiteInicio', sortable: true },
                { text: 'Estado', value: 'status', filter: true },
            ],
            items: [],
            dialogo: false,
            errorEmpty: null,
            selectedPractitionerId: null,
            selectedRecipeId: null,
            mostrarItemsPracticante: [],
            rowsPerPage: 10,
            formattedDate: '',
            practitionerId: this.$route.params.id,
        };
    },
};
</script>

<style scoped>
.info-practicante {
    margin-bottom: 30px;
}

.data-section {
    background-color: #f8f9fa;
    padding: 20px;
    border-radius: 8px;
    width: 100%;
    max-width: 800px;
    margin: 0 auto;
}

.data-row {
    margin-bottom: 15px;
    display: flex;
    align-items: baseline;
}

.label {
    color: #00bfff; /* Color celeste eléctrico */
    font-weight: 500;
    min-width: 150px;
    margin-right: 10px;
}

.value {
    color: #333;
}

.text-center {
    text-align: center;
}

.cont-botones {
    gap: 5px;
    display: flex;
    align-items: center;
}

.customize-table {
    background-color: var(--color-principal);
    color: white;
}

.operation-icon {
    color: var(--color-principal);
    cursor: pointer;
}

.operation-wrapper {
    display: flex;
    align-items: center;
}

.error-message {
    color: var(--color-error);
    font-weight: bold;
    text-align: center;
    margin-top: 20px;
}
</style>
